<div #navbarSelectMenu class="main-row">
    <select class="form-control flex-fill location select-menu" [(ngModel)]="selectedLocation"
                    (ngModelChange)="onLocationClick()">
                    <option [ngValue]="null" selected>{{ 'Location' | translate }}</option>
                    <option *ngFor="let loc of locations; index as index" [ngValue]="loc"> {{ loc.name }}</option>
                </select>
                <select class="form-control flex-fill select-menu" (change)="onVisitClick($event)"
                    *ngIf="visitsPerSpace && visitsPerSpace.length > 1">
                    <option value="default" selected disabled hidden>{{'Visit' | translate}}</option>
                    <option *ngFor="let visit of visitsPerSpace; index as index" value="{{index}}">{{ visit.name}}
                    </option>
                </select>
                <select class="form-control flex-fill floor select-menu" [(ngModel)]="selectedFloor"
                    (ngModelChange)="onFloorClick()">
                    <option [ngValue]="null" selected>{{'Floor' | translate}}</option>
                    <option *ngFor="let zone of floorsPerSpace" [ngValue]="zone">{{ zone.name}}</option>
                </select>
                <select class="form-control flex-fill select-menu zone" [(ngModel)]="selectedZone"
                    (ngModelChange)="onZoneClick()">
                    <option [ngValue]="null" selected>{{'Zone' | translate}}</option>
                    <option *ngFor="let zone of zonesPerFloor" [ngValue]="zone">{{ zone.name}}</option>
                </select>
                <select class="form-control flex-fill select-menu" [(ngModel)]="selectedChildZone"
                    *ngIf="childrenZones && childrenZones.length>0">
                    <option [ngValue]="null" selected disabled>{{'Zone' | translate}}</option>
                    <option *ngFor="let zone of childrenZones" [ngValue]="zone">{{ zone.name}}</option>
                </select>
   
    <button (click)="goTo()" class="btn rounded-pill btn-museum btn-visit"
        [disabled]="!selectedLocation || !selectedModel3d || !canGo()">{{'Go to 3D visit' | translate}}</button>
</div>
<h4 style="line-height: 29px;margin: 0;" *ngIf="showLocation()">
    {{ showLocation() }}
</h4>

